/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_OpeningInputs */

const en_plan_opening = /** @type {(inputs: Plan_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening...`)
};

const es_plan_opening = /** @type {(inputs: Plan_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abriendo...`)
};

/**
* | output |
* | --- |
* | "Opening..." |
*
* @param {Plan_OpeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_opening = /** @type {((inputs?: Plan_OpeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_OpeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_opening(inputs)
	return en_plan_opening(inputs)
});